import React, { useEffect, useState } from 'react';
import Table from '../../../components/Tables/ExpandedTable';
import { headerMaker } from '../../../components/Tables/ExpandedTable/helper';
import { productsHeader } from '../../../redux/modules/table/common';
import { useDispatch, useSelector } from 'react-redux';
import reports from '../../../services/reports';
import rateType from '../../../services/ratingtype';
import Spinner from '../../../components/Spinner';
import { setReportSubData } from '../../../redux/modules/application/actions';
import { makeReport } from '../../../utils/makeReport';
import { workConstructor } from '../../../utils/workConstructor';
import { setPage } from '../../../redux/modules/modalwork/actions';
import { useShowModal } from '../../../hooks';
import works from '../../../services/works';
import { Pagination } from 'antd';
import { setModalLoading } from '../../../redux/modules/modals/actions';
import RatedWork from '../../../components/Cards/TaskCard';
import DatePicker from '../../../components/DatePicker';
import { groupHeaders } from '../../../utils/groupHeader';

export default () => {
  const dispatch = useDispatch();
  const { showBlured } = useShowModal();
  const [headers, setHeaders] = useState([]);
  const [newHeader, setNewHeader] = useState([]);

  useEffect(() => {
    const foo = headerMaker(productsHeader.concat(groupHeaders(newHeader)));
    setHeaders(foo);
  }, [newHeader]);

  const { singleDate } = useSelector((state) => state.selectedDateReducer);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );

  const { page, modalWork } = useSelector((state) => state.modalWork);
  const { regionId, groupId, userId } = useSelector(
    (state) => state.authReducer
  );
  const [reportsData, setReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const { constructorMethod } = workConstructor();

  const fetchRateReports = async () => {
    try {
      setLoading(true);
      const data = {
        date: singleDate,
        user: userId,
        group: groupId,
      };
      const reportData = await reports.getAllDaiyReport(data);
      const ratesType = await rateType.getAll();
      const myCat = reportData[0]?.categorys.map((i) => i.category);
      setNewHeader(categories.filter((i) => myCat.includes(i._id)));
      const report = makeReport(
        reportData,
        regions,
        groups,
        categories,
        users,
        ratesType
      );
      setReportsData(report.sort((a, b) => b.total.value - a.total.value));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (singleDate) {
      fetchRateReports();
    }
  }, [singleDate, categories, groups, regions]);

  const handleSelectgroup = async (id, userId) => {
    try {
      setLoadingSub(true);
      const data = {
        date: singleDate,
        category: id,
        group: groupId,
        user: userId,
      };
      const resp = await reports.getAllDaiyReport(data);
      const subCats = categories.filter((item) => item.parent === id);
      const report = subCats.map((item, idx) => {
        const subCat = resp.find((itm) => itm.subCategory === item._id);
        return {
          id: idx + 1,
          name: item?.title,
          subCategoryId: item?._id,
          total: subCat?.rate
            ? Math.min(Math.round(subCat?.rate), 100)
            : subCat?.rate,
          categoryId: id,
          user: userId,
          groupId: groupId,

          // regionId: regionId,
        };
      });
      dispatch(setReportSubData(report ? report : []));
      setLoadingSub(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onChangePage = (p) => {
    dispatch(setPage(p));
  };

  useEffect(() => {
    if (page > 0) {
      setWorksModal();
    }
    // return () => dispatch(clearState());
  }, [page]);

  const setWorksModal = async (data) => {
    dispatch(setModalLoading(true));
    try {
      const reqData = {
        startDate: singleDate,
        endDate: singleDate,
        region: regionId,
        group: groupId,
        user: userId,
        subCategory: modalWork?.subCategoryId
          ? modalWork?.subCategoryId
          : data?.subCategoryId,
        page: page === 0 ? 1 : page,
        limit: 1,
        status: 3,
      };
      const common = { categories, regions, groups, users };
      const resp = await works.getAll(reqData);
      const workerData = constructorMethod(resp.docs, common);
      dispatch(setModalLoading(false));
      showBlured({
        title: 'Works',
        maxWidth: '90vw',
        maxHeight: '85vh',
        withHeader: false,
        body: () => (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            {workerData?.length > 0 ? (
              <>
                <RatedWork data={workerData[0]} medium borderLess />
                <Pagination
                  current={page === 0 ? 1 : page}
                  pageSize={1}
                  onChange={onChangePage}
                  total={resp?.totalPages}
                  // size="large"
                />
              </>
            ) : null}
          </div>
        ),
      });
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <>
      <div style={{ width: '100%', padding: '20px 0' }}>
        <DatePicker />
      </div>

      <Table
        data={reportsData}
        headers={headers}
        selectgroup={handleSelectgroup}
        loading={loadingSub}
        setWorksModal={setWorksModal}
      />
    </>
  );
};
